module.exports = __webpack_public_path__ + "img/okchain1.fbbfceeb.png";